<template>
  <div class="pt-6 grid grid-cols-1 gap-x-8 gap-y-8 md:grid-cols-5">
    <div class="px-4 sm:px-0 relative">
      <div>
        <h2 class="text-base font-semibold leading-7 text-gray-900">Input Mapping</h2>
        <p class="mt-1 text-sm leading-6 text-gray-600">Define how to process input data. You can make input data available for the bot to use in the answers.</p>
      </div>
    </div>
    <div class="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-4">
      <div class="px-4 py-2">
        <div class="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-6 sm:grid-cols-6">
          <StdPropArrayEditor
            class="col-span-full"
            v-model="inputMapping"
            :label="propsDefs['inputMapping'].title"
            :description="propsDefs['inputMapping'].description"
            :propertiesSpec="inputMappingSpecProps"
          ></StdPropArrayEditor>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
  import { standardBotPropsByName } from '@/spec/BotTypeDefs';
  import { useBotsStore } from '@/store/BotsStore';
  import { computed } from 'vue';
  import StdPropArrayEditor from '@/components/Editors/StdPropArrayEditor.vue';

  const botsStore = useBotsStore();

  const propsDefs = standardBotPropsByName;

  const inputMappingSpecProps = [
    { name: 'key', type: 'string', title: 'Key', description: 'Key in the input properties', default: '' },
    { name: 'userContext', type: 'boolean', title: 'Enable to place property value to User Context, so bot can use this data in answers.', default: false },

    /*
    { name: 'definition', type: 'text', title: 'Definition', default: '' },
    { name: 'examples', type: 'text', title: 'Examples', description: 'Provide detailed examples of what user may say for this intent', default: '' },
    { name: 'instructions', type: 'text', title: 'Instructions', description: 'Provide detailed instructions for the bot what to do for this intent', default: '' },
    { name: 'integrations', type: 'stringLong', title: 'Integrations', description: 'List of Integrations Bot can use when this intent is detected', default: '' },
    */

    /*
    { name: 'type', type: 'selectLong', title: 'Type', description: 'Select type of action', options: ['Link', 'Calendly Meeting'], values: ['link', 'calendlyMeeting'], default: 'link' },
    { name: 'conditionType', type: 'select', title: 'When to show', description: 'Select when to show action', options: ['Always', 'When Tags are set'], values: ['always', 'tags'], default: 'always' },
    { name: 'tagsValue', type: 'string', title: 'Tags', description: 'List of tags (comma-separated)', default: '', when: (i) => i.conditionType === 'tags' },
    { name: 'name', type: 'stringLong', title: 'Name', default: '' },
    { name: 'value', type: 'stringLong', title: 'URL', default: '' },
    { name: 'hubspotMeetingAuto', type: 'boolean', title: 'Open Booking Widget Automatically', default: false, when: (i) => i.type === 'hubspotMeeting' },
    { name: 'handoffOnMeetingBooked', type: 'boolean', title: 'Handoff when meeting is booked', default: false, when: (i) => i.type === 'calendlyMeeting' },
    */
  ];

  const inputMapping = computed(botsStore.getPropGetSet('inputMapping'));
</script>
